<template>
  <default-layout>
    <delete-confirm-comp
      @close="deleteAction = false"
      v-if="deleteAction"
      title="Delete user"
      question="Are you sure to delete this user?"
      description="User can only deleted by user admin. Cannot undo deleted user"
      :dataId= "`Delete user ${deleteName}`"
      :loading="loading"
      @delete="deleteUser"
      :error="errorMessage"
    ></delete-confirm-comp>
    <form-layout
      v-if="formLayout"
      @close="formLayout = false"
      titleForm="User Form"
      :title="titleForm"
      btnTitle="Save"
      :isEdit="isEdit"
      :loading="loading"
      @action="createUser"
      :error="errorMessage"
    >
    <v-row>
          <v-col cols="12">
            <v-text-field
              label="Name"
              outlined
              dense
              hide-details
              :readonly="isEdit"
              class="c-text-field"
              v-model="createUserData.name"
            ></v-text-field>
          </v-col>
    </v-row>
    <v-row>
          <v-col cols="12">
            <v-text-field
              label="Email"
              outlined
              dense
              hide-details
              :readonly="isEdit"
              class="c-text-field"
              v-model="createUserData.email"
            ></v-text-field>
          </v-col>
    </v-row>
    <v-row>
          <v-col cols="12">
            <v-text-field
              label="Password"
              outlined
              dense
              hide-details
              :readonly="isEdit"
              class="c-text-field"
              v-model="createUserData.password"
            ></v-text-field>
          </v-col>
    </v-row>
    </form-layout>
    <v-card class="c-card-wrapper" elevation="2">
      <div class="header-card-wrapper">
        <v-card-title>Users</v-card-title>
      </div>
      <div class="action-top">
        <p style="margin: 0" class="">List Users</p>
        <v-btn
          rounded
          small
          depressed
          class="c-btn-primary"
          @click="createFormCb"
        >
          Create User
        </v-btn>
      </div>
      <div class="body-card-wrapper">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="max-width: 25px; width: 25px"></th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Name
                </th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Email
                </th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody class="tbody-card-wrapper">
              <tr v-for="item in users" :key="item.id" class="tr-hover">
                <td>
                  <v-icon large> mdi-account </v-icon>
                </td>
                <td
                  style="max-width: 150px; word-wrap: break-word"
                  class="td-select"
                >
                  {{ item.name }}
                </td>
                <td style="max-width: 150px; word-wrap: break-word">
                  {{ item.email }}
                </td>
                <td style="max-width: 150px; word-wrap: break-woMiningrd">
                  <v-btn
                    @click="deleteMethodForm(item.id, item.name)"
                    elevation="2"
                    color="transparent"
                    class="v-no-background-hover btn-action"
                    style="box-shadow: none !important"
                  >
                    <v-icon> mdi-trash-can </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
  </default-layout>
</template>

<script>
import DeleteConfirmComp from "@/components/elements/DeleteConfirmComp.vue";
import DefaultLayout from "./layout/DefaultLayout.vue";
import FormLayout from "@/components/layout/FormLayout.vue";
import ListUserApi from '@/api/listUser';
import CreateUserApi from "@/api/createUser"
import DeleteUserApi from "@/api/deleteUser"

export default {
  async created(){
    await this.loadUser();
  },
  components: { DefaultLayout, DeleteConfirmComp, FormLayout },
  methods:{
    editFormCb(){
        this.formLayout = true;
        this.titleForm = "Edit User"
        this.isEdit = true
    },
    createFormCb(){
        this.errorMessage = ""
        this.formLayout = true;
        this.titleForm = "Create User"
        this.isEdit = false;
        this.createUserData.email = ""
        this.createUserData.name = ""
        this.createUserData.password = ""
    },
    deleteMethodForm(id, name){
      this.errorMessage = ""
      this.deleteName = name;
      this.deleteAction = true;
      this.deleteUserId = id;
    },
    async deleteUser(){
      this.loading = true;
      const del = await DeleteUserApi(this.deleteUserId);
      this.loading = false;
      if(del.status != "00"){
        this.errorMessage = del.error.message;
        return;
      }
      this.loadUser()
      this.deleteAction = false;
    },
    async loadUser(){
      const data = await ListUserApi(1);
    this.users = [];
    data.data.data.forEach(d=>{
      this.users.push({
        name: d.name,
        email: d.email,
        id: d.userId
      })
    })
    this.page = data.page;
    this.totalPage = data.totalPage;
    },
    async createUser(){
      this.loading = true;
      const res  = await CreateUserApi(this.createUserData);
      this.loading = false;
      if(res.status != "00"){
         this.errorMessage = res.error.message;
         return;
      }
      await this.loadUser()
      this.formLayout = false;
    }
  },
  data() {
    return {
      errorMessage: '',
      deleteUserId: '',
      loading: false,
      deleteName: "",
      page: 1,
      totalPage: 0,
      deleteAction: false,
      formLayout: false,
      titleForm: "Create User",
      isEdit: false,
      users: [],
      createUserData:{
        name: "",
        email:"",
        password:""
      }
    };
  },
};
</script>
